import React from 'react';
import PropTypes from 'prop-types';
import { CheckboxContainer, HiddenCheckbox, StyledCheckbox, Icon, Text } from './styled';

const Checkbox = ({
  checked,
  name,
  children,
  onChange,
  className,
  variant,
  icon,
  ...props
}) => {
  return (
    <CheckboxContainer className={className}>
      <HiddenCheckbox checked={checked} onChange={onChange} {...props} />
      <input type="hidden" name={name} value="False" />
      <StyledCheckbox checked={checked} hasChildren={children} variant={variant}>
        {icon || <Icon />}
      </StyledCheckbox>
      <Text>{children}</Text>
    </CheckboxContainer>
  );
};

Checkbox.propTypes = {
  checked: PropTypes.bool,
  name: PropTypes.string,
  children: PropTypes.node,
  onChange: PropTypes.func,
  className: PropTypes.string,
  variant: PropTypes.string,
  icon: PropTypes.node
};

export default Checkbox;
